module.exports = __webpack_public_path__ + "img/deqing.1c7b70d3.png";